import React from "react";
import "./Logoco.css";

const Logoco = (url) => {
    const image = url.url;
    console.log(image);
    
    return (
        <div className="modern-logo-container">
            <img src={image} className="modern-logo-image" alt="Motel Logo" />
        </div>
    );
};

export default Logoco;
